<ng-container [formGroup]="formBaggageFilter">
    <label class="container" *ngFor="let baggage of baggages; let i = index">
        <input type="checkbox" (click)="sendFilterOptionBaggage(baggage, i)" [value]="baggage"
            [formControl]="baggageFilterArray.at(i)">
        <span class="checkmark"></span>
        {{ baggage == 0 ? 'Com Bagagem Despachada' : 'Apenas bagagem de mão' }}
    </label>
</ng-container>